import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { ArrowForward } from "@mui/icons-material";

import { PAGE_ROUTES } from "../../utils/stateTypes";

const styles = {
  main: {
    minHeight: "60vh",
    display: "flex",
    alignItems: "center",
    textAlign: "center",
  },
  text: {
    margin: "20px 0 32px 0",
  },
};

const NotFound = () => {
  return (
    <section
      className={"section"}
      style={styles.main}
    >
      <Helmet>
        <title>Page not found | Janine Botha Attorneys</title>
        <meta
          name={"robots"}
          content={"noindex"}
        />
      </Helmet>
      <div className={"container-narrow"}>
        <h1 className={"h-section"}>
          {"Page not "}
          <span className={"script script-green"}>found</span>
        </h1>
        <p
          className={"lead"}
          style={styles.text}
        >
          The page you&apos;re looking for doesn&apos;t exist or has moved.
        </p>
        <Link
          to={PAGE_ROUTES.HOME}
          className={"btn-pill"}
        >
          Back to home
          <ArrowForward />
        </Link>
      </div>
    </section>
  );
};

export default NotFound;
